"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.borderWidthTertiary = exports.borderWidthSecondary = exports.borderWidthPrimary = exports.borderWidthNone = exports.borderRadiusXSmall = exports.borderRadiusXLarge = exports.borderRadiusSmall = exports.borderRadiusRadioButton = exports.borderRadiusNone = exports.borderRadiusMedium = exports.borderRadiusLarge = exports.borderRadiusCircle = void 0;
const borderWidthNone = exports.borderWidthNone = '0px';
const borderWidthPrimary = exports.borderWidthPrimary = '1px';
const borderWidthSecondary = exports.borderWidthSecondary = '1.5px';
const borderWidthTertiary = exports.borderWidthTertiary = '2px';
const borderRadiusNone = exports.borderRadiusNone = '0px';
const borderRadiusXSmall = exports.borderRadiusXSmall = '4px';
const borderRadiusRadioButton = exports.borderRadiusRadioButton = '6px';
const borderRadiusSmall = exports.borderRadiusSmall = '8px';
const borderRadiusMedium = exports.borderRadiusMedium = '12px';
const borderRadiusLarge = exports.borderRadiusLarge = '20px';
const borderRadiusXLarge = exports.borderRadiusXLarge = '30px';
const borderRadiusCircle = exports.borderRadiusCircle = '50%';